import {IconButton} from '@dropbox/dig-components/buttons';
import {Tooltip} from '@dropbox/dig-components/tooltips';
import {UIIcon} from '@dropbox/dig-icons';
import {PinFill, PinLine} from '@dropbox/dig-icons/assets';

/**
 * /workstreams: a recent's pin toggle (the rail, the Recently viewed
 * strip, a workstream's page), filled while pinned. Its clicks stay its own, so
 * a row or card it sits on doesn't open too. Where it isn't on the list it pins
 * to (a workstream's page), `target` names that list.
 */
export const PinToggleButton = ({
  pinned,
  onToggle,
  target,
}: {
  pinned: boolean;
  onToggle: () => void;
  target?: string;
}) => {
  const label = target
    ? pinned
      ? `Unpin from ${target}`
      : `Pin to ${target}`
    : pinned
      ? 'Unpin'
      : 'Pin';
  return (
    <Tooltip title={label} placement="top">
      <IconButton
        variant="transparent"
        size="small"
        aria-label={label}
        aria-pressed={pinned}
        onMouseDown={(event: React.MouseEvent) => event.preventDefault()}
        onClick={(event: React.SyntheticEvent) => {
          event.preventDefault();
          event.stopPropagation();
          onToggle();
        }}
      >
        <UIIcon src={pinned ? PinFill : PinLine} size="small" />
      </IconButton>
    </Tooltip>
  );
};
